<template>
    <div>
        <block v-if="loading"></block>
        
        <!-- Acordeón de descarga de archivos -->
        <div class="px-4 mb-4">
            <v-expansion-panels v-model="expansionPanel" style="background: #fff;">
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <span class="text-h6">Descarga de archivos</span>
                        <template v-slot:actions>
                            <v-chip color="primary" small>
                                {{ invoicesCount }} facturas
                            </v-chip>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-card rounded="lg">
                            <v-card-text class="px-0 pt-0">
                                <!-- Filtros de estado de facturas -->
                                <div class="mt-10 mb-5 ml-4">
                                    <v-row>
                                        <v-col cols="12" md="3">
                                            <v-checkbox
                                                v-model="filter.showProcessed"
                                                @change="onFilterChange"
                                                label="Mostrar procesadas"
                                                color="info"
                                                hide-details
                                                :disabled="TipoPlan == 'Contabilidad'"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="3" v-if="TipoPlan != 'Contabilidad'">
                                            <v-checkbox
                                                v-model="filter.showInvalid"
                                                @change="onFilterChange"
                                                label="Mostrar invalidadas"
                                                color="info"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="3" v-if="TipoPlan != 'Contabilidad'">
                                            <v-checkbox
                                                v-model="filter.showRejected"
                                                @change="onFilterChange"
                                                label="Mostrar rechazadas"
                                                color="info"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col cols="12" md="3" v-if="TipoPlan != 'Contabilidad'">
                                            <v-checkbox
                                                v-model="filter.showContingency"
                                                @change="onFilterChange"
                                                label="Mostrar en contingencia"
                                                color="info"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                    </v-row>

                                    <v-row class="me-0 mt-5">
                                        <v-col cols="12" sm="6" lg="4" md="4" class="margin-bottom" >
                                            <v-text-field v-model="filter.ID_Customer" label="ID del Cliente" outlined hide-details="auto" dense></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" lg="4" md="4" class="margin-bottom" >
                                            <v-text-field v-model="filter.LegalName" label="Nombre legal" outlined hide-details="auto" dense></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" lg="4" md="4" class="margin-bottom" >
                                            <v-select v-model="filter.InvoiceType" :items="[
                                                    { name: 'CONSUMIDOR FINAL', value: 'FCF' },
                                                    { name: 'CRÉDITO FISCAL', value: 'CCF' },
                                                    { name: 'SUJETO EXCLUIDO', value: 'FNS' },
                                                    { name: 'EXPORTACIÓN', value: 'FEX' },
                                                    { name: 'COMPROBANTE DE DONACIÓN', value: 'CDD' },
                                                    { name: 'NOTA DE REMISIÓN', value: 'DNR' },
                                                    { name: 'NOTA DE CRÉDITO', value: 'DNC' },
                                                    { name: 'NOTA DE DÉBITO', value: 'DND' },
                                                ]" item-text="name" item-value="value"
                                                outlined dense label="Tipo de Documento" hide-details="auto" />
                                        </v-col>
                                    </v-row>
                                </div>

                                <date-filter
                                    ref="dateFilter"
                                    @filtered-data="dateFilterHandler"
                                    @reset-data="getAllInvoices"
                                    :dataToFilter="invoices"
                                    :search="{ ...this.filter, showAllRecords: this.showAllRecords }"
                                    nameOfDate="History"
                                    :filterEndpoint="$API.invoices.getInvoicesFilteringByDates"
                                    :isFilteredByOutsource="false"
                                >
                                    <template #default>
                                        <PrintPdfJsonProgrammatic 
                                            :data="filteredInvoices" 
                                            @setLoading="(e) => loading = e"
                                            @displaySuccessAlert="() => showAlert('success', 'Descarga exitosa', 'Documentos descargados con éxito.')"
                                            @displayErrorAlert="() => showAlert('danger', 'Error al imprimir', 'Ha ocurrido un error al imprimir, por favor intente de nuevo. si el problema persiste contacte al administrador del sistema.')"
                                        />
                                    </template>
                                </date-filter>
                            </v-card-text>
                        </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>

        <alerts style="z-index: 20000 !important;"
            v-if="alert.show"
            v-on:close_alert="closeAlert"
            v-on:accept_alert="acceptAlert"
            :properties="alert"
        >
        </alerts>
    </div>
</template>

<script>
    import Block from "@/components/Block";
    import Alerts from "@/components/Alerts";
    import DateFilter from '../../components/DateFilter.vue';
    import PrintPdfJsonProgrammatic from '../../components/POS/PrintPdfJsonProgrammatic.vue';
    import moment from 'moment/moment';

    export default {
        name: "DownloadInvoices",
        components: { PrintPdfJsonProgrammatic, Block, Alerts, DateFilter },
        props: ['win'],
        data() {
            return {
                loading: false,
                expansionPanel: 0, // Acordeón abierto desde el inicio
                invoices: [],
                filteredInvoices: [],
                filter: {
                    codPointSale: localStorage.getItem("codPointSale"),
                    ID_Branch: JSON.parse(localStorage.getItem("user")).branch || "",
                    ID_Business: JSON.parse(localStorage.getItem("user")).businessid || "" ,
                    user: JSON.parse(localStorage.getItem("user")).id || "",
                    status: 1,
                    istemplate: 0,
                    typeData: '01',
                    showFNS: this.$store.getters['rolesUser/getCustomRole'](247) ? true : false,
                    showInvalid: true,
                    showRejected: false,
                    showContingency: true,
                    showProcessed: true,
                },
                showAllRecords: true,
                alert: {
                    type: "success",
                    show: false,
                    header: "",
                    body: "",
                },
                TipoPlan: JSON.parse(localStorage.getItem("user"))?.TipoPlan || null,
            }
        },
        computed: {
            invoicesCount() {
                return this.filteredInvoices?.length || 0;
            }
        },
        mounted() {
             this.getAllInvoices()
        },
        watch: {
            filteredInvoices: {
                handler(newVal) {
                    console.log('Facturas filtradas actualizadas:', newVal.length);
                },
                deep: true
            }
        },
        methods: {
            async reloadDataByDate(payload) {
                try {
                    this.loading = true
                    payload.start = moment(payload.start, "DD/MM/YYYY").format("YYYY-MM-DD")
                    payload.end = moment(payload.end, "DD/MM/YYYY").format("YYYY-MM-DD")
                    const response = await this.$API.invoices.getInvoicesFilteringByDates(
                        { ...payload, ...this.filter, showAllRecords: this.showAllRecords })
                    this.invoices = response // Actualizar las facturas originales
                    this.dateFilterHandler(response) // Actualizar las facturas filtradas
                } catch(err) {
                    console.error(err)
                    this.showAlert(
                        "error",
                        "Error",
                        `Ha ocurrido un error al consultar la información: ${err}`
                        );
                } finally {
                    this.loading = false
                }
            },

            dateFilterHandler(filteredData) {
                console.log('Datos filtrados por fecha:', filteredData.length);
                this.filteredInvoices = filteredData || [];
            },

            onFilterChange() {
                // Si hay fechas seleccionadas, usar el filtrado por fechas que incluye las casillas
                // Si no hay fechas, usar el método general
                const dateFilter = this.$refs.dateFilter;
                if (dateFilter && dateFilter.startDate && dateFilter.endDate) {
                    // Refiltrar con las fechas actuales y las nuevas casillas
                    this.reloadDataByDate({
                        start: dateFilter.startDate,
                        end: dateFilter.endDate
                    });
                } else {
                    // Si no hay fechas seleccionadas, cargar todos los datos con las nuevas casillas
                    this.getAllInvoices();
                }
            },

            closeAlert() {
                this.alert.show = false;
            },

            showAlert(type, header, body, options = null) {
                type = type == null ? "danger" : type;
                this.alert.type = type;
                this.alert.header = header;
                this.alert.body = body;
                this.alert.show = true;
                this.alert.options = options != null ? options : null;
            },

            getAllInvoices() {
                this.loading = true
                const filterWithLimit = {
                    ...this.filter,
                    showAllRecords: this.showAllRecords
                };
                console.log('Cargando facturas con filtro:', filterWithLimit);
                
                this.$API.invoices.getInvoicesPOSHistory(filterWithLimit)
                    .then(response => {
                        this.loading = false
                        console.log('Facturas cargadas:', response.length);
                        this.invoices = response || []
                        this.filteredInvoices = response || [] // Inicializar las facturas filtradas con todas las facturas
                    })
                    .catch(error => {
                        this.loading = false
                        console.error('Error al cargar facturas:', error);
                        this.showAlert('error', 'Error', 'No se pudieron cargar las facturas');
                        this.invoices = []
                        this.filteredInvoices = []
                    })
            }
        }
    }
</script>

<style scoped>
.background {
    background: white !important;
    color: white;
}
</style>